import { CHAR_TAB, CHAR_LF, CHAR_CR, CHAR_SPACE } from '../constants/characterCodes'

export const isNullOrEmpty = (str) => {
  return !str || str.trim() === ''
}

// convert a string into number where result is bounded: [minNumber, maxNumber)
export const stringToNumberInRange = (str, minNumber, maxNumber) => {
  const range = maxNumber - minNumber
  const result = isNullOrEmpty(str)
    ? 0
    : str
      .split('')
      .reduce((sum, c) => ((c.charCodeAt(0) + sum) % range), 0)

  return result + minNumber
}

/**
 * Remove characters from a string
 * @param {string} text - The string containing characters to remove
 * @param {Object} options - Specifiy which characters are to be removed
 * @param {bool} options.removeNewline - If true, the carriage return and newline characters will be removed.
 *                                       Defaults to false
 * @param {bool} options.removeTabs - If true, the tab character will be removed. Defaults to false
 * @param {bool} options.removeControlChars - If true, the non-printable control characters will be removed.
 *                                            Defaults to true.
 * @param {int} options.replacementChar - The character to insert for each removed character. Defaults to ''
 */
export const removeCharacters = (text, options) => {
  var opts = {
    removeControlChars: true,
    replacementChar: '',
    ...options }
  var newText = ''
  for (let i = 0; i < text.length; ++i) {
    let charval = text.charCodeAt(i)
    let remove = false
    if (charval === CHAR_LF || charval === CHAR_CR) {
      remove = !!opts.removeNewline
    } else if (charval === CHAR_TAB) {
      remove = !!opts.removeTabs
    } else if (charval < CHAR_SPACE) {
      remove = !!opts.removeControlChars
    }

    if (!remove) {
      newText += text[i]
    } else if (opts.replacementChar !== '') {
      newText += opts.replacementChar
    }
  }
  return newText
}



// WEBPACK FOOTER //
// ./src/util/stringHelper.js